export const KEYBOARD_KEY_ARROW_UP = 'ArrowUp';
export const KEYBOARD_KEY_ARROW_DOWN = 'ArrowDown';
